module.exports = __webpack_public_path__ + "static/img/1002_big.7445313.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1002_big.png
// module id = br13
// module chunks = 1